const API_KEY = 'AIzaSyDKSHOjEWO3fWq5MWLrJmavVJd7MucgtuQ';

export default API_KEY;


// WEBPACK FOOTER //
// ./src/utils/ApiKey.js